export default {
  // 0：未过期，1：失效，2：已过期，3：停止发放 枚举类
  COUPON_STATUS: {
    notExpired: 0,
    invalid: 1,
    expired: 2,
    stop: 3,
  },
  // 文字描述不同
  COUPON_STATUS_NAME: {
    0: '未过期',
    1: '失效',
    2: '已过期',
    3: '停止发放',
  },
  // 优惠券类型
  CONPON_TYPE: {
    fullReduction: 0,
    discount: 1,
    noThreshold: 2,
  },
  CONPON_TYPE_LIST: [
    {
      label: '无门槛劵',
      value: 2,
    },
    {
      label: '满减劵',
      value: 0,
    },
    {
      label: '折扣劵',
      value: 1,
    },
  ],
  CONPON_TYPE_LIST_NAME: {
    0: '满减劵',
    1: '折扣劵',
    2: '无门槛劵',
  },
  COUPON_TIME_TYPE: {
    fixed: 0,
    afterReceiving: 1,
  },
  COUPON_TIME_TYPE_LIST: [
    {
      label: '固定时间',
      value: 0,
    },
    {
      label: '领取后生效',
      value: 1,
    },
  ],
  COUPON_APPLY_TYPE: {
    0: '全部商品',
    1: '指定商品',
    2: '不参与商品',
    3: '选择分组',
  },
  COUPON_APPLY_TYPE_4_DETAIL: {
    0: '全部商品',
    1: '部分商品使用',
    2: '不参与商品',
    3: '选择分组',
  },
  USER_COUPON_STATUS: {
    unused: 0,
    used: 1,
  },
  USER_COUPON_STATUS_LIST: [
    {
      label: '未使用',
      value: 0,
    },
    {
      label: '已使用',
      value: 1,
    },
    {
      label: '已过期',
      value: 2,
    },
    {
      label: '已失效',
      value: 3,
    },
  ],
  COUPON_APPLY_TYPE_NAME: {
    all: 0,
    joinGoods: 1,
    notJoinGoods: 2,
    groups: 3,
  },
  DEF_COUPON_ITEM: {
    id: '',
    name: '',
    amount: undefined,
    // 0：固定时间；1：领取后生效
    couponTimeType: 0,
    type: null,
    goodsFlag: 0,
    couponTimeRanger: [],
    receiveInstructions: '',
    discountInstructions: '',
    useInstructions: '',
    discount: undefined,
    // 0：全部商品，1：指定商品，2：不参与商品 ，3：选择分组
    notJoinGoods: [], // spuId
    joinGoods: [], // spuId
    groups: [], // gid
    notJoinGroups: [],
    perLimit: undefined,
    thresholdAmount: undefined,
    publishCount: undefined,
    receiveCount: null,
    startReceiveDay: null,
    status: null,
    validityDay: null,
    couponCenterFlag: 1,
    couponTask: false,
  },
};
